module.exports = __webpack_public_path__ + "static/cgr-e7a1f845803ade72f163da6270a08e47.png";